import Smartphones from 'Events/Deposit/views/DepositView/containers/Smartphones'
import Tablets from 'Events/Deposit/views/DepositView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const DepositView = getCurrentDeviceView(Smartphones, Tablets)

export default DepositView
